/* global document */

// Keep the fade in step with `transition: opacity` on #globalLoader in
// splashScreenStyles.css.
export const SPLASH_FADE_MS = 250;

// The first call marks the moment the app first became usable. Module-level so
// it fires once per page load, however many of the ~10 call sites (several of
// which call this during render) run.
let appReadyMarked = false;

const markAppReady = () => {
  if (appReadyMarked) return;
  appReadyMarked = true;
  // Import-free on purpose: instrumentation-client.ts observes this mark and
  // records it as Sentry's `app.ready` measurement (lib/bootTelemetry.ts).
  try {
    if (typeof performance !== "undefined" && performance.mark) {
      performance.mark("app-ready");
    }
  } catch (error) {
    // String-only: Mixpanel replay renders objects as [object Object].
    console.error(`[boot] app-ready mark failed: ${String(error)}`);
  }
};

const removeLoader = () => {
  if (typeof window !== "undefined") {
    markAppReady();
    const loader = document.getElementById("globalLoader");
    if (loader) {
      // Let clicks through the fading veil at once — before the opacity
      // change, in the same tick — instead of blocking them for the fade.
      loader.style.pointerEvents = "none";
      loader.style.opacity = "0";

      setTimeout(() => {
        loader.style.display = "none";
      }, SPLASH_FADE_MS);
    }
  }
};

/** Test-only: forget that the app-ready mark was made. */
export const resetAppReadyMarkForTests = () => {
  appReadyMarked = false;
};

export default removeLoader;
